<template>
    <cookie v-if="!cookieConsentRequired" />
    <dashboard-view v-else-if="isAuthenticated && !passwordHash && !accessDenied && gdprAccepted" />
    <gdpr-screen v-else-if="isAuthenticated && !gdprAccepted" />
    <access-denied v-else-if="isAuthenticated && accessDenied"/>
    <login-view v-else-if="$route.name !='organization-registration'" />
    <organization-registration v-else />
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState('user', ['cookieConsentRequired', 'isAuthenticated', 'passwordHash', 'accessDenied', 'gdprAccepted']),
    },
};
</script>
